import { apiClient } from "~/apiClient";

export const cacheEcomOrder = async (shopId: string, orderName: string) => {
  return await apiClient(`/api/v2/customer/cache_ecom_orders`, {
    method: "POST",
    body: { orderName: orderName, filter: { shopId: { eq: shopId } } },
  });
};
